export function triproutesQuoteCurrent(quote, signature) {
 return Boolean(quote && quote.signature === signature && (quote.attempted || Date.parse(quote.expiresAt) > Date.now()));
}

export async function startTriproutesLaunch({ api, solution, body, key, quote, isCurrent, onQuote, attemptId }) {
 const signature = JSON.stringify(body);
 if (!isCurrent()) return null;
 if (!triproutesQuoteCurrent(quote, signature)) {
  const conditions = await api.request(`/v1/triproutes/${solution}/quote`, { method: "POST", body, ...(attemptId ? {headers:{"X-Harness-Launch-Attempt":attemptId}} : {}) });
  if (!isCurrent()) return null;
  quote = { ...conditions, signature };
 }
 if (!isCurrent()) return null;
 // Keep this quote and key after a lost acknowledgement so retrying cannot create another job.
 onQuote({ ...quote, attempted: true });
 const resource = solution === "city-routes" ? "batches" : "jobs";
 return api.request(`/v1/triproutes/${solution}/${resource}`, {
  method: "POST", headers: { "Idempotency-Key": key, "X-Harness-Launch-Quote": quote.id, ...(attemptId ? {"X-Harness-Launch-Attempt":attemptId} : {}) }, body,
 });
}
